export function draftStorageKey(scope, suffix = 'live-class') {
  return `d28d-draft:${suffix}:${scope || 'platform'}`;
}

export function loadDraft(key) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveDraft(key, data) {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}

export function clearDraftStorage(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function confirmDiscardChanges(
  message = 'Tienes cambios sin guardar en el formulario. ¿Continuar sin guardar?',
) {
  return window.confirm(message);
}

export function formHasLiveClassDraft(form) {
  if (!form) return false;
  return Boolean(
    form.id
    || String(form.title || '').trim()
    || form.start_time
    || form.end_time
    || form.d28d_routine_id
    || String(form.description || '').trim(),
  );
}
